import { initialMenuState } from './menu-store';
import { createStore, initialStoreState, IStore } from './store';

export interface IMenuStoreModel {
  isLoading: boolean;
  selectedMenu: string;
  isSideNavOpened: boolean;
}

export interface ICustomerPortalGlobalStore {
  menu: IMenuStoreModel;
  store: IStore;
}

export const initialCustomerPortalGlobalStoreState: ICustomerPortalGlobalStore =
  {
    menu: initialMenuState,
    store: initialStoreState
  };

export const {
  Provider: CustomerPortalGlobalStoreProvider,
  useStore: useCustomerPortalGlobalStore,
  useSetStore: useSetCustomerPortalGlobalStore,
  useSetStorePath: useSetCustomerPortalGlobalStorePath
} = createStore<ICustomerPortalGlobalStore>(
  initialCustomerPortalGlobalStoreState
);
